import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, ShoppingBag, Share2, Wallet, Megaphone } from "lucide-react";

const BOTTOM_NAV = [
  { to: "/dashboard", label: "Home", icon: LayoutDashboard, testid: "bnav-dashboard" },
  { to: "/shop", label: "Shop", icon: ShoppingBag, testid: "bnav-shop" },
  { to: "/rewards", label: "Rewards", icon: Share2, testid: "bnav-rewards" },
  { to: "/earnings", label: "Wallet", icon: Wallet, testid: "bnav-earnings" },
  { to: "/marketing", label: "Marketing", icon: Megaphone, testid: "bnav-marketing" },
];

export default function MobileBottomNav() {
  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-[#0F2042]/95 backdrop-blur-xl border-t border-white/10 pb-[max(env(safe-area-inset-bottom),0px)]"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-stretch justify-around">
        {BOTTOM_NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            data-testid={n.testid}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center justify-center gap-0.5 py-2.5 text-[10px] uppercase tracking-widest font-bold transition-colors ${
                isActive ? "text-[#FBBF24]" : "text-white/55 hover:text-white"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <n.icon size={18} className={isActive ? "drop-shadow-[0_0_6px_rgba(251,191,36,0.6)]" : ""} />
                <span>{n.label}</span>
                {isActive && <span className="h-0.5 w-6 -mb-1.5 bg-[#FBBF24] rounded-full" />}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
